module.exports = __webpack_public_path__ + "img/lock.aa6de193.svg";